/* eslint-disable global-require,import/no-unresolved,max-len,class-methods-use-this */
import React from 'react'
import { ScrollView, Text, View } from 'react-native'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import styles, { colors } from '../../styles'
import textStyles from '../../styles/text'
import { createParagraphText } from '../subcomponents/contentHelper'
import { displayTelephoneLine } from '../methods/RegionalContentLookUp'

class BestConnectionPage extends React.Component {
  getTelephoneLineSection() {
    const { locale, t } = this.props
    let objToReturn
    if (displayTelephoneLine(locale)) {
      objToReturn = (
        <View style={{ padding: 16 }} testID="best-connection-telephone-line">
          {createParagraphText(t, 'common:standardTelephone', styles.monitorHeading)}
          {createParagraphText(t, 'standardTelephoneLineSubTitle', textStyles.bodyContentText)}
          {createParagraphText(t, 'standardTelephoneContentOne', textStyles.bodyContentText)}
          {createParagraphText(t, 'standardTelephoneContentTwo', textStyles.bodyContentText)}
        </View>
      )
    }
    return objToReturn
  }

  render() {
    const { t } = this.props
    return (
      <View style={{ flex: 1 }}>
        <ScrollView
          style={{ backgroundColor: colors.white }}
          testID="scrollview-WhatConnectionMethod"
        >
          <View style={styles.stepsContainer}>
            <Text style={[textStyles.h1, styles.shark_grey]}>
              {t('whichBestConnectionTitle')}
            </Text>
          </View>
          <View style={{ padding: 16 }}>
            {createParagraphText(t, 'common:usbEthernetAdapter', styles.monitorHeading)}
            {createParagraphText(t, 'usbEthernetAdapterSubTitle', textStyles.bodyContentText)}
            {createParagraphText(t, 'usbEthernetAdapterContentOne', textStyles.bodyContentText)}
            {createParagraphText(t, 'usbEthernetAdapterContentTwo', textStyles.bodyContentText)}
            {createParagraphText(t, 'usbEthernetAdapterContentThree', textStyles.bodyContentText)}
          </View>
          <View style={{ padding: 16 }}>
            {createParagraphText(t, 'common:usbCellularAdapter', styles.monitorHeading)}
            {createParagraphText(t, 'usbCellularAdapterSubTitle', textStyles.bodyContentText)}
            {createParagraphText(t, 'usbCellularAdapterContentOne', textStyles.bodyContentText)}
            {createParagraphText(t, 'usbCellularAdapterContentTwo', textStyles.bodyContentText)}
          </View>
          {this.getTelephoneLineSection()}
        </ScrollView>
      </View>
    )
  }
}

BestConnectionPage.propTypes = {
  t: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
}

const mapStateToProps = (state) => {
  const { storedData } = state
  return {
    locale: storedData.locale,
  }
}

export const BestConnectionPageComponent = BestConnectionPage

export default withTranslation(['bestConnection'])(connect(mapStateToProps, null)(BestConnectionPage))
